import React, { useEffect } from 'react'

import image2 from './Image2/campus3.jpeg'
import four from "./facilitiesphotos/four.png"
import { BsFillArrowRightCircleFill } from 'react-icons/bs'

import landscape from './facilitiesphotos/landscape.jpg'
import pharm from './Image2/phrms.jpg'
import { Link } from 'react-router-dom'
import {Helmet} from "react-helmet";

const About = () => {



  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <>
      <Helmet>
        <title>About Us Page</title>
        <meta name="description" content="Information about shinde institute of pharmacy and research" />
      </Helmet>



      <div style={{ marginTop: "6rem" }}>
        <img src={landscape} alt="error" className="landscape" style={{ width: "100%" }}></img>
        <center>  <h1 className="centered">Home {'>'} About us  </h1>  </center>
      </div>

      <div className='container' style={{ marginTop: "4rem" }} >
        <div className='row animated animatedFadeInUp fadeInUp'>
          <center><h1 style={{ color: "rgb(44, 110, 17)" }}>  <span style={{ color: "rgb(151 201 29)" }}>Girnai </span> Shikshan Sanstha</h1>
            <h2 className='mt-3' style={{ color: "rgb(44, 110, 17)" }}><span style={{ color: "rgb(151 201 29)" }}> Welcome to shinde </span>  institute of pharmacy and research</h2></center>
          <br />
          <br />
          <br />

          <div className='col-md-6 mt-5 ' >
            {/* <h2 style={{ color: "rgb(44, 110, 17)" }}>WHO ARE<span style={{ color: "rgb(44 110 17)" }}> WE?</span></h2> */}

            <p className="text-dark" style={{ color: "rgb(44 110 17)" }} >
              <span className='h3 font-weight-bold' style={{ color: "rgb(44, 110, 17)" }} > Shinde institute of pharmacy and research </span> established in year 2022 with a vision of empowerment of nation with knowledgeable pharmacist by promoting quality pharmaceutical education to uplift from rural Maharashtra.

            </p>
            <p className="text-dark" > <span> <BsFillArrowRightCircleFill style={{ color: "rgb(44, 110, 17)" }} /> Modern state of art infrastructure wi fi campus</span><br></br>
              <span><BsFillArrowRightCircleFill style={{ color: "rgb(44, 110, 17)" }} />	 Well furnish adigital library with E books,text books and reference booksand international journals</span><br></br>
              <span><BsFillArrowRightCircleFill style={{ color: "rgb(44, 110, 17)" }} />	Govt. financial assistance schem like EBC and minority schorlarship also freeship to respective category (SC,ST,NT,OBC and SBC)</span><br></br>
              <span><BsFillArrowRightCircleFill style={{ color: "rgb(44, 110, 17)" }} />	Dynamic, Experienced and dedicated faculty</span><br></br>
              <span><BsFillArrowRightCircleFill style={{ color: "rgb(44, 110, 17)" }} />	Well equipped computer center with broadband internet</span><br></br>
              <span><BsFillArrowRightCircleFill style={{ color: "rgb(44, 110, 17)" }} />	Sophisticated instrument lab Medicinal plant garden</span><br></br>
              <span><BsFillArrowRightCircleFill style={{ color: "rgb(44, 110, 17)" }} />	Facility like boys common room, girls common room, cafeteria and sports</span><br></br>
              <span><BsFillArrowRightCircleFill style={{ color: "rgb(44, 110, 17)" }} />	College bus facility for student and staff</span>
            </p>


          </div>

          <div className='col-md-6 mt-5' >
            <center>  <img src={image2} alt='error13' className='img-fluid '></img></center>

          </div>


        </div>
        <br />
        <div className='row animated animatedFadeInUp fadeInUp'>
          <div className='col-md-6 '>
            <h3 style={{ color: "rgb(44, 110, 17)" }}> VISION</h3>
            <p className='text-dark'>
              Developing and conducting research to improve the safety and efficiency of the medication use system.</p>

          </div>
          <div className='col-md-6'>
            <h3 style={{ color: "rgb(44, 110, 17)" }}>MISSION</h3>
            <p className='text-dark'>Our mission is to educate and inspire a diverse group of future pharmaceutical scientist to be leaders ,advance patient care and improve health for all.
              To generate human resource in the profession of pharmacy.
            </p>

          </div>
        </div>


        <div className='row animated animatedFadeInUp fadeInUp mt-1' >

          <div className='col-md-6' style={{ marginTop: "1rem" }} >
            <center>  <img src={four} alt='error13' className='img-fluid '></img></center>

          </div>
          <div className='col-md-6' >

            <h3 style={{ color: "rgb(44, 110, 17)" }} className="mt-3">INFRASTRUCTURE</h3>

            <p className='text-dark mt-4'>
              The college is well known for the kind of facilities that it offers to make learning pleasure. For instance, a huge well stocked library offers a vast array of books, magazine and other reference material related to pharmacy.
              The college has invested heavily in thechnology so that student can avail state of the art equipment. the college also has a medicinal plant garden that consist of vast variety of herbs.

            </p>
            <p className='text-dark'>We are a private limited company, via our expert team of maids services staff assist people from India to find a solution for their home
              assistance needs. Using our maid services people can search home maids across any Indian cities.</p>
            <br />





          </div>

        </div>
        <br></br>
        <div className='row'>



          <div className='col-md-6' style={{ marginTop: "1rem" }} >
            <h3 style={{ color: "rgb(44, 110, 17)" }}>OPPORTUNITY AND FUTURE SCOPE</h3>
            <p>In Production, Quality assurance, Quality Control, Regulatory Affairs, IPR, Marketing, Production development, Research and development.
              Clinical research, pharmacovigilance, clinical data management in FDA.
            </p>

            <p>
              In Government<br></br>
              <BsFillArrowRightCircleFill style={{ color: "rgb(44, 110, 17)" }} />  Drug inspectore,assistant commissioner and joint commissioner in FDA<br></br>
              <BsFillArrowRightCircleFill style={{ color: "rgb(44, 110, 17)" }} />   As a pharmacist in government hospital as well as hospital run by zilla parishad.<br></br>
              <BsFillArrowRightCircleFill style={{ color: "rgb(44, 110, 17)" }} /> As a Drug Procurement officer.<br></br>
              <BsFillArrowRightCircleFill style={{ color: "rgb(44, 110, 17)" }} /> In academics as a asst. Professor, assoc professor in various pharmacy college.<br></br>

            </p>

          </div>
          <div className='col-md-6' >

            <img src={pharm} alt="error" className='img-fluid'></img>


          </div>




        </div>





      </div>


      <br></br>
      <br></br>

      <div className='row head2 footer-booknow margin-bottom' style={{ background: "rgb(77 135 25)", marginBottom: "-2.9rem" }} >

        <div className='col-lg-8 col-md-8 ' style={{ color: "white", marginTop: "1.2rem", marginBottom: "1.2rem" }} >
          <center> <h3 className='small2'>Are you looking for Pharmacy <br></br> College ?</h3></center>

        </div>
        <div className='col-lg-4 col-md-4' style={{ color: "white", marginTop: "2.5rem" }}>
          <center>  <h4 className='small3 '><i className="fa fa-phone-square" ></i> Call +91 83800 48830 or  <span>    <Link to="/" type="button" className="btn btn-outline-warning mx-1" >
            Know more
          </Link></span></h4></center>


        </div>
      </div>







    </>
  )
}

export default About